/**
 * A person's name guessed from their email address, so a form needs only the address (owner 2026-10-17, "minimal
 * input"): anna.svensson@ → Anna Svensson. Shared mailboxes (info@, faktura@ …) give no name.
 */

const SHARED = new Set(['info', 'hej', 'hello', 'kontakt', 'contact', 'admin', 'office', 'kontoret', 'order', 'faktura', 'fakturor', 'invoice', 'invoices', 'ekonomi', 'economy', 'support', 'noreply', 'no-reply', 'mail', 'post', 'reception', 'marketing', 'marknad', 'sales', 'hr', 'jobb', 'press']);

const cap = (w: string) => w.charAt(0).toLocaleUpperCase('sv') + w.slice(1).toLocaleLowerCase('sv');

/** null when the address has no usable name (a shared mailbox, digits only, not an address). */
export function nameFromEmail(email: string): string | null {
  const local = email.trim().split('@')[0]?.split('+')[0]?.toLocaleLowerCase('sv') ?? '';
  if (!local || !email.includes('@') || SHARED.has(local)) return null;
  const words = local
    .split(/[._]+/)
    .map((w) => w.replace(/\d+/g, '').replace(/^-+|-+$/g, ''))
    .filter(Boolean);
  if (!words.length) return null;
  return words.map((w) => (w.length === 1 ? `${w.toLocaleUpperCase('sv')}.` : w.split('-').map(cap).join('-'))).join(' ');
}
